import { AnyObject } from '@mecontrol/common';

export interface MeControlError extends Error {
    mcIsTimeout?: boolean;
}

const meControlErrorPrefix = 'MeControlError::';

/**
 * Create a Me Control error object with a given message
 * @param message Error message
 * @param isTimeout Flag to indicate whether the error is because of a timeout
 */
export function createError(message: string, isTimeout: boolean = false): MeControlError {
    const error: MeControlError = new Error(`${meControlErrorPrefix}${message}`);
    error.mcIsTimeout = isTimeout;
    return error;
}

/**
 * Convert an error object into a similar object that can be converted
 * to a JSON string
 * @param err Error to convert
 */
export function toJsonable(err: Error): any {
    let newObj: AnyObject = {};
    let oldObj: AnyObject = err;
    Object.getOwnPropertyNames(err).forEach(propName => newObj[propName] = oldObj[propName]);
    return newObj;
}
